import { createElement } from "react";

import styled from "styled-components";

import { txt } from "../../../../../locales/i18n";

import type { LayoutPanels, BaseContainer, Text, Carousel } from "./utils";
import * as LayoutUtils from "./utils";
import { Skeleton } from "antd";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";

export const carouselLayoutPanels: LayoutPanels = {
	layoutName: txt('cms.layoutNames.carousel'),
	panels: [
		{
			label: txt('cms.panelNames.layout container'),
			formKey: 'container',
			type: 'baseContainerPanel',
		},

		{
			label: txt('cms.panelNames.title'),
			formKey: 'title',
			type: 'textPanel',
		},

		{
			label: txt('cms.panelNames.carousel'),
			formKey: 'carousel',
			type: 'carouselPanel',
		}
	]
}

export const carouselLayoutValues: CarouselLayoutProps = {
	container: LayoutUtils.defaultBaseContainer,

	title: {
		color: '#333',
		text: 'Title Tekst',
		isBold: false,
		isItalic: false,
		isUnderlined: false,
		textAlign: 'center',
		fontFamily: "'Montserrat Variable', sans-serif",
		htmlTag: 'h2',
		animation: LayoutUtils.defaultAnimation,
	},

	carousel: {
		category: 1,
	}
}

type CarouselLayoutProps = {
	container: BaseContainer,
	title: Text,
	carousel: Carousel,
}

export const CarouselLayout = (props: CarouselLayoutProps) => {

	const title = createElement(props.title.htmlTag, {
		className: 'title',
		dangerouslySetInnerHTML: { __html: LayoutUtils.formatText(props.title.text) },
		...LayoutUtils.getAnimationProps(props.title.animation),
	})

	return (
		<CarouselLayoutStyled $={props}>
			{props.title.text !== '' && title}
			<div className="experiences">
				<FontAwesomeIcon icon={faChevronLeft} size="2x" color="#EF8F49" />
				<div className="experience">
					<div className="image-container"><Skeleton.Image /></div>
					<Skeleton paragraph={{rows: 2}}/>
				</div>
				<div className="experience">
					<div className="image-container"><Skeleton.Image/></div>
					<Skeleton paragraph={{rows: 2}}/>
				</div>
				<div className="experience">
					<div className="image-container"><Skeleton.Image/></div>
					<Skeleton paragraph={{rows: 2}}/>
				</div>
				<FontAwesomeIcon icon={faChevronRight} size="2x" color="#EF8F49" />
			</div>
		</CarouselLayoutStyled>
	)
}

const CarouselLayoutStyled = styled.div<{ $: CarouselLayoutProps }>`
	padding: 2rem;

	background-repeat: no-repeat;
	background-color: ${({ $ }) => $.container.backgroundColor};
	background-size: ${({ $ }) => $?.container?.coverFit ?? 'cover'};
	background-position: ${({ $ }) => $?.container?.coverPosition ?? 'center'};
	background-image: ${({ $ }) => {
		if ($.container.coverSource === '') return 'none'
		return `url(${LayoutUtils.getImageSource($.container.coverSource)})`
	}};

	min-height: ${({ $ }) => ($.container.fullscreen ? '100dvh' : 'auto')};

	.title {
		${({ $ }) => LayoutUtils.getTextStyle($.title)};
		margin: 0 0 24px 0;
	}

	.experiences {
		display: flex;
		align-items: center;
		gap: 2rem;
		justify-content: space-between;
		margin: 24px 0;
	} 

	.experience {
		display: flex;
		flex-direction: column;
		flex: 1;
		box-shadow: 0 0 15px #e2e2e2;
		max-width: 20%;
		background-color: #fffdfa;
	}

	.image-container {
		flex: 1;
		background-color: #F2F2F2;

		.ant-skeleton {
			display: flex;
			justify-content: center;
		}

		.ant-skeleton-image {
			background: none;
		}
	}
`